<div class="attribute-container">
  <div class="attribute-text dropdown">
    <form-factory [formGroup]="measureYearFormGroup" [model]="measureYear"></form-factory>
  </div>
</div>
<div class="attribute-container">
  <div class="attribute-text dropdown">
    <form-factory [formGroup]="measureYearFormGroup" [model]="reportingYear"></form-factory>
  </div>
</div>
<div class="subSectionHeader">
  <div class="attribute-text">
    <form-factory [formGroup]="measureYearFormGroup" [model]="autocloseMemberCompliantChase"></form-factory>
  </div>
</div>
<div class="subSectionHeader">
  <div class="attribute-text">
    <form-factory [formGroup]="measureYearFormGroup"
      [model]="autocloseMemberCompliantChaseForRecentEventMeasure"></form-factory>
  </div>
</div>
<div class="subSectionHeader">
  <div class="attribute-text">
    <form-factory [formGroup]="measureYearFormGroup" [model]="nrcRequired"></form-factory>
  </div>
</div>
<div class="subSectionHeader">
  <div class="attribute-text">
    <form-factory [formGroup]="measureYearFormGroup" [model]="demographicRequired"></form-factory>
  </div>
</div>
<div class="subSectionHeader">
  <div class="attribute-text">
    <form-factory [formGroup]="measureYearFormGroup" [model]="dataEntryProviderConfirmationEnabled"></form-factory>
  </div>
</div>
<div class="subSectionHeader" *ngIf="isRetrievalTypeGap">
  <div class="attribute-text">
    <form-factory [formGroup]="measureYearFormGroup" [model]="gapProviderOutreachEnabled"></form-factory>
  </div>
</div>